import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { SumRegistrationPricesPipe } from "./sum-registration-prices.pipe";

@NgModule({
  declarations: [SumRegistrationPricesPipe],
  imports: [CommonModule],
  exports: [SumRegistrationPricesPipe],
  providers: [SumRegistrationPricesPipe],
})
export class SumRegistrationPricesPipeModule {}
